import React from "react";
import { IconProps } from "./icon-types";

const IconElement = ({ value, className }: IconProps) => {
  const iconName = typeof value === "string" ? value : value?.value;
  return <i className={`la la-${iconName} ${className}`} />;
};

export default IconElement;
